import React, { useContext, useEffect, useState } from 'react';
import { ZdsDivider, ZdsDwellingCard } from '@zig-design-system/ui-components-react';
import { RootContext } from '../../../../Context/RootContext';
const ComplexCard = ({ complex, url, currentView }) => {
    const complexCardRef = React.useRef(null);
    const [imageNotFoundError, setImageNotFoundError] = useState(false);
    const assetPaths = useContext(RootContext).assetPaths;
    const imageNotFoundUrl = assetPaths.sitepackage + 'Images/imagenotfound_4x3.jpg';
    useEffect(() => {
        var _a;
        (_a = complexCardRef === null || complexCardRef === void 0 ? void 0 : complexCardRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('zdsClick', handleScroll);
        return () => {
            var _a;
            (_a = complexCardRef === null || complexCardRef === void 0 ? void 0 : complexCardRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('zdsClick', handleScroll);
        };
    }, []);
    const handleScroll = ((event) => {
        sessionStorage.setItem('complexCardScrollY', window.scrollY.toString());
    });
    const imageSrc = imageNotFoundError ? imageNotFoundUrl : complex.list_image || imageNotFoundUrl;
    return (React.createElement("div", null,
        React.createElement(ZdsDwellingCard, Object.assign({}, (currentView === 'tiles'
            ? {
                horizontal: false,
                streetHighlighted: false,
                priceHighlighted: false,
            }
            : {}), (currentView === 'list'
            ? {
                horizontal: true,
                streetHighlighted: true,
                priceHighlighted: true,
            }
            : {}), { street: complex.name, city: complex.city, district: complex.quarter, link: url, ref: complexCardRef, bodyPadded: !!complex.house_type }),
            React.createElement("img", { slot: "media", src: imageSrc, onError: ({ currentTarget }) => {
                    if (!imageNotFoundError) {
                        currentTarget.src = imageNotFoundUrl;
                        setImageNotFoundError(true); // sets the value to true after attempting to load fallback image
                    }
                } }),
            complex.status && (React.createElement("div", { slot: "status", className: "zds-bg-secondary" }, complex.status)),
            complex.house_type && React.createElement("span", { slot: "description" }, complex.house_type)),
        currentView === 'list' && React.createElement(ZdsDivider, { className: "zds-margin-y-4" })));
};
export default ComplexCard;
